import { ResponseObject } from "../../../common/interfaces/global-interfaces"
import { SystemUserRole } from "../system-configurations/temp-fcrs/system-user-role/system-user-role.model"

export interface AuthUserProfile {
  id?: string
  uniqueId?: string
  firstName?: string
  middleName?: string
  lastName?: string
  fullName?: string
  email?: string
  gender?: string
  profilePhone?: string
  profilePhoto?: string
  isHandover?: boolean
  isDeactivated?: boolean
  accountType?: UserTypeEnum;
  ageGroup?: AgeRangeTypeChoices;
  isVisible?: boolean
  isActive?: boolean
  createdDate?: string
}


export interface InstitutionAuthUser {
  id?: string;
  uniqueId?: string;
  userType?: any;
  userProfile?: AuthUserProfile;
  role?: SystemUserRole;
  profileDesignation?: any;
}

export interface UserDetails {
  id?: string;
  uniqueId?: string;
  accountType?: any;
  userProfile?: AuthUserProfile;
  profileRole?: SystemUserRole;
}

export interface ProfileInputObject {
  uniqueId?: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  email?: string;
  gender?: string;
  profilePhone?: string;
  profilePhoto?: string;
  ageGroup?: AgeRangeTypeChoices;
  isVisible?: boolean;
  fullName?: string;
  password?: string;
}

export interface OTPInputObject {
  phoneNumber: string;
  otp: number;
}

export interface ResendOTPMutation {
  resendTime: number;
  response: ResponseObject;
}


export enum UserTypeEnum {
  COMPLAINANT = 'COMPLAINANT',
  INTERNAL = 'INTERNAL',
  ADMIN = 'ADMIN',
  TOP_LEADERS = 'TOP_LEADERS'
}

export enum DepartmentUserTypesChoices {
  STAFF = 'STAFF',
  HOD = 'HOD',
}

export enum DepartmentSectionUserTypesChoices {
  STAFF = 'STAFF',
  HOS = 'HOS',
}

export enum VerificationTypeChoices {
  RESETPASSWORD = 'RESETPASSWORD',
  PROFILEUPDATE = 'PROFILEUPDATE',
  COMPLAINTSUBMISSION = 'COMPLAINTSUBMISSION',
}

export enum AgeRangeTypeChoices {
  CHILD = 'CHILD',
  TEENAGER = 'TEENAGER',
  ADULT = 'ADULT',
  SENIOR = 'SENIOR',
}
